import { api } from "./config";

export const saveEmployerQuery = async (data) => {
  try {
    const res = await api.post("employer/contact-us", data);
    return res;
  } catch (error) {
    return error.response;
  }
};